import React from 'react';
interface RuleKeyChipProps {
  ruleKey: string;
  onClick: () => void;
}
export function RuleKeyChip({
  ruleKey,
  onClick
}: RuleKeyChipProps) {
  return <button type="button" onClick={onClick} title="Open in the Rules tab" className="inline-flex items-center rounded-sm border border-sf-border-strong bg-white px-1.5 font-mono text-[11px] leading-[18px] text-sf-blue transition-colors duration-150 ease-out hover:border-sf-blue hover:bg-sf-blue-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sf-blue" data-id="element-428" data-mp="38tj0aeq6gdkk">
      {ruleKey}
    </button>;
}